import React from 'react'
import "./Needhelp.scss"
import Layout from '../../component/layout/Layout';
import { Link } from 'react-router-dom';
function Needhelp() {
    return (
        <>
            <Layout >
                <div className='mob_h1'>
                    <h1 className='mobile_content '>Welcome to </h1>
                    <h1 className='mobile_content '>
                        DLF Mall Of India
                    </h1>
                </div>
                <div className="helpbox">
                    <div className="inner_center_box">
                    <label className="tophead" >
                    Please let us know if you are having trouble in getting the OTP
                     </label>
                        <div className="form-check_1">
                            <div className='div_center'>
                                <input className="form-control mobile" type="text" placeholder="Email address *" aria-label="default input example" />
                            </div>
                            <div className='div_center'>
                                <input className="form-control mobile" type="text" placeholder="Trouble you are facing *" aria-label="default input example" />
                            </div>
                           
                            <button>Submit</button>
                            <p><Link to="/login"><span className='high_light_text'>Back to Login</span></Link></p>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default Needhelp